// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactDataDto
 */
export interface IContactDataDto {
    /**
     * 
     * @type {number}
     * @memberof IContactDataDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IContactDataDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     */
    org_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IContactDataDto
     */
    is_email_verified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     */
    phone_number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IContactDataDto
     */
    is_phone_verified?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContactDataDto
     */
    email_communication_type_list?: Array<IContactDataDtoEmailCommunicationTypeListEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof IContactDataDto
     */
    clock_in?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     */
    role_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDataDto
     * @deprecated
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof IContactDataDto
     */
    role_id?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof IContactDataDto
     */
    job_function_types?: Set<IContactDataDtoJobFunctionTypesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum IContactDataDtoEmailCommunicationTypeListEnum {
    FINANCE = 'FINANCE',
    FILES = 'FILES',
    PLAN_MANAGEMENT = 'PLAN_MANAGEMENT',
    REPORTS = 'REPORTS'
}
/**
* @export
* @enum {string}
*/
export enum IContactDataDtoJobFunctionTypesEnum {
    ACCOUNT_MANAGER = 'ACCOUNT_MANAGER'
}


/**
 * Check if a given object implements the IContactDataDto interface.
 */
export function instanceOfIContactDataDto(value: object): value is IContactDataDto {
    return true;
}

export function IContactDataDtoFromJSON(json: any): IContactDataDto {
    return IContactDataDtoFromJSONTyped(json, false);
}

export function IContactDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
        'title': json['title'] == null ? undefined : json['title'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'is_email_verified': json['is_email_verified'] == null ? undefined : json['is_email_verified'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'is_phone_verified': json['is_phone_verified'] == null ? undefined : json['is_phone_verified'],
        'email_communication_type_list': json['email_communication_type_list'] == null ? undefined : json['email_communication_type_list'],
        'clock_in': json['clock_in'] == null ? undefined : json['clock_in'],
        'role_name': json['role_name'] == null ? undefined : json['role_name'],
        'role': json['role'] == null ? undefined : json['role'],
        'role_id': json['role_id'] == null ? undefined : json['role_id'],
        'job_function_types': json['job_function_types'] == null ? undefined : new Set(json['job_function_types']),
    };
}

export function IContactDataDtoToJSON(json: any): IContactDataDto {
    return IContactDataDtoToJSONTyped(json, false);
}

export function IContactDataDtoToJSONTyped(value?: IContactDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'org_path': value['org_path'],
        'title': value['title'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'email': value['email'],
        'is_email_verified': value['is_email_verified'],
        'phone_number': value['phone_number'],
        'is_phone_verified': value['is_phone_verified'],
        'email_communication_type_list': value['email_communication_type_list'],
        'clock_in': value['clock_in'],
        'role_name': value['role_name'],
        'role': value['role'],
        'role_id': value['role_id'],
        'job_function_types': value['job_function_types'] == null ? undefined : Array.from(value['job_function_types'] as Set<any>),
    };
}

